// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 779 ? "056bf7cd" : chunkId) + "-" + {"123":"8fb3533d445bafa92aeb","779":"dbd731c3cc0ee09ca942"}[chunkId] + ".js";
};